import { Pipe, PipeTransform } from '@angular/core';
import { Promo } from '../Model/Promo.Model';

@Pipe({
  name: 'PromoFilter',
  standalone: false
})
export class PromoFilterPipe implements PipeTransform {

  transform(promos: Promo[], searchTerm: string, field: string): Promo[] {
    if (!promos || !searchTerm) return promos;

    const lowerSearchTerm = searchTerm.toLowerCase();

    return promos.filter(promo => this.matchesSearchTerm(promo, lowerSearchTerm));
  }

  private matchesSearchTerm(promo: Promo, term: string): boolean {
    const fieldsToCheck: (keyof Promo)[] = [
      'promoEventName',
      'comment',
      'promoObjectivesLabel',
      'marketCompanyName'
    ];

    return fieldsToCheck.some(field => {
      const value = promo[field];
      return value != null && value.toString().toLowerCase().includes(term);
    });
  }
}
